<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                            v-model="search.rental_fee"
                            class="form-control select"
                            placeholder="ห้องพัก"
                            :options="OptionRentalFee"
                            label="rental_name"
                            :show-labels="false"
                            track-by="id">
                    </multiselect>
                    &nbsp
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchRentalFee"
                            type="button">
                        <icon name="search">
                        </icon> ค้นหา
                    </button>&nbsp
                    <button class="btn btn-warning my-2 my-sm-0"
                            @click="createRentalFee"
                            type="button">
                        <icon name="plus"></icon> เพิ่มห้องพัก
                    </button>&nbsp
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">ห้องพัก</th>
                    <th scope="col">ราคาค่าไฟ/หน่วย</th>
                    <th scope="col">ราคาค่าน้ำ/คน</th>
                    <th scope="col">จำนวนผู้พักอาศัย</th>
                    <th scope="col">ค่าห้องพัก</th>
                    <th scope="col">ดูข้อมูล</th>
                    <th scope="col">แก้ไข/ยกเลิก</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in rentalList">
                    <td>{{++index}}</td>
                    <td>{{data.rental_name}}</td>
                    <td>{{data.bill | currency }}</td>
                    <td>{{data.water_price | currency }}</td>
                    <td>{{data.count}}</td>
                    <td>{{data.rent_price | currency }}</td>
                    <td>
                        <button class="btn btn-primary"
                                @click="goToElectricityBill(data.id)">
                            ดูข้อมูล
                        </button>
                    </td>
                    <td>
                        <a @click="editRentalFee(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp&nbsp
                        <a @click="showModalDelete(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!--b-modal-->
        <b-modal hide-header hide-footer ref="rental_fee">
            <rental-fee-modal @submit="saveRentalFee" :optionEmployee="employeeAll">
            </rental-fee-modal>
        </b-modal>

        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br />
                <button
                        type="button"
                        class="btn btn-success"
                        @click="deleteRentalFee">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                        type="button"
                        class="btn btn-outline-secondary"
                        @click="hideModalDelete">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <div v-if="rentalList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getRentalList">
            </vue-pagination>
        </div>
        <br>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status_loading"></loading>
        </b-modal>
<!--        <pre class="alert-success">{{search}}</pre>-->
    </div>
</template>

<script>
    import RentalFeeModal from "./Modal/RentalFeeModal";
    import { mapState } from "vuex"
    import VuePagination from "../../../Pagination";
    import Multiselect from "vue-multiselect";
    import Loading from "../../../Utility/Loading";
    export default {
        components: {
            Loading,
            RentalFeeModal,
            VuePagination,
            Multiselect
        },
        name: "rental-fee-list",
        created(){
            this.$store.dispatch("RentalFee/setRentalFee");
            this.$store.dispatch("RentalFee/getRentalFeeAll");
            this.$store.dispatch("RentalFee/clearFormData");
            this.$store.dispatch("RentalFee/clearSearch");
            this.$store.dispatch("Employee/getEmployeeAll").then(res=>{
                this.employeeAll = res.filter( data=> !data.rental_fee_id);
            });
        },
        computed:{
            ...mapState({
                rentalList:state=>{
                    return state.RentalFee.rentalFeeList;
                },
                OptionRentalFee:state=>{
                    return state.RentalFee.rentalFeeListAll;
                },
                dataPaginate:state=>{
                    return state.RentalFee.dataPaginate;
                },
                search:state =>{
                    return state.RentalFee.search;
                },
            })
        },
        data() {
            return {
                msg : '',
                status_loading : '',
                employeeAll : [],
                id: "",
                event_submit : false,
            };
        },
        methods:{
            getRentalList(){
                const page = this.dataPaginate.current_page;
                this.msg = 'รอสักครู่';
                this.status_loading = 1;
                this.showLoadingModal();
                //paginate search
                if(this.event_submit){
                    if(this.search.rental_fee){
                        this.search.rental_fee_id = this.search.rental_fee.id
                    }
                    else{
                        this.search.rental_fee_id = ""
                    }
                    let data={
                        page : page,
                        rental_fee_id : this.search.rental_fee_id
                    };
                    this.$store.dispatch('RentalFee/search',data).then(()=>{
                        this.hideLoadingModal();
                    })
                }
                //paginate get data
                else{
                    this.$store.dispatch('RentalFee/setRentalFee',page).then(()=>{
                        this.hideLoadingModal();
                    })
                }

            },
            searchRentalFee(){
                this.event_submit = true;
                //change date format

                if(this.search.rental_fee){
                    this.search.rental_fee_id = this.search.rental_fee.id
                }
                else{
                    this.search.rental_fee_id = ""
                }
                this.msg = 'รอสักครู่';
                this.status_loading = 1;
                this.showLoadingModal();
                this.$store.dispatch("RentalFee/search",this.search).then(()=>{
                    this.hideLoadingModal();
                })
            },
            showRentalFeeModal(){
                this.$refs.rental_fee.show();
            },
            hideRentalFeeModal(){
                this.$refs.rental_fee.hide();
            },
            showModalDelete(id) {
                this.$refs.delete_item.show();
                this.id = id;
            },
            hideModalDelete() {
                this.$refs.delete_item.hide();
            },
            showLoadingModal(){
                this.$refs.loading.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            createRentalFee(){
              this.$store.dispatch("RentalFee/clearFormData").then(()=>{
                  this.showRentalFeeModal();
              })
            },
            saveRentalFee(submitData){
                if(submitData == 0){
                    this.$store.dispatch("RentalFee/clearFormData");
                }
                else{
                    this.msg = 'รอสักครู่';
                    this.status_loading = 1;
                    this.showLoadingModal();
                    this.$store.dispatch("RentalFee/saveRentalFee",{
                        id : submitData.id,
                        data : submitData
                    }).then(()=>{
                        this.$store.dispatch("RentalFee/setRentalFee");
                        this.$store.dispatch("Employee/getEmployeeAll").then(res=>{
                            this.employeeAll = res.filter( data=> !data.rental_fee_id);
                        });
                        this.hideLoadingModal();
                    });
                    this.$store.dispatch("RentalFee/clearFormData");
                }
                this.hideRentalFeeModal();
            },
            editRentalFee(id){
                this.msg = 'รอสักครู่';
                this.status_loading = 1;
                this.showLoadingModal();
                this.$store.dispatch("RentalFee/showRentalFeeByID",id).then(()=>{
                    this.hideRentalFeeModal();
                    this.$refs.rental_fee.show();
                })
            },
            deleteRentalFee(){
                this.$store.dispatch("RentalFee/delete",this.id).then(() => {
                    this.hideModalDelete();
                    this.$store.dispatch("RentalFee/setRentalFee");
                });
            },
            goToElectricityBill(rental_fee_id){
                this.msg = 'กรุณารอสักครู่';
                this.status_loading = 1;
                this.showLoadingModal();
                this.$store.dispatch("RentalFee/showRentalFeeByID",rental_fee_id).then(()=>{
                    this.$store.dispatch("ElectricityBill/setElectricityBill",{
                        rental_fee_id : rental_fee_id,
                        page : 1
                    })
                    this.$router.push({
                        name : "electricity-bill-list"
                    })
                })
            }
        }
    }
</script>

<style scoped>
    .select{
        border: 0px
    }
</style>
